var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        {
          staticClass: "title",
          attrs: { "align-baseline": "", "justify-space-between": "" }
        },
        [
          _c("v-flex", { attrs: { xs1: "" } }, [
            _vm._v("\n      " + _vm._s(_vm.$t("labelDetails")) + ":\n    ")
          ]),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { md2: "" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  "hide-details": "",
                  items: _vm.templates,
                  "return-object": "",
                  label: _vm.$t("template"),
                  "item-text": "name"
                },
                on: { change: _vm.onSelectTemplate }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs1: "" } },
            [
              _c(
                "v-menu",
                {
                  attrs: {
                    "close-on-content-click": false,
                    "nudge-right": 40,
                    lazy: "",
                    transition: "scale-transition",
                    "offset-y": "",
                    "full-width": "",
                    "min-width": "290px"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function(data) {
                        return [
                          _c(
                            "v-text-field",
                            _vm._g(
                              {
                                attrs: {
                                  "hide-details": "",
                                  value: _vm.shipDate,
                                  label: _vm.$t("shipDate"),
                                  readonly: ""
                                }
                              },
                              data.on
                            )
                          )
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.shipDateMenu,
                    callback: function($$v) {
                      _vm.shipDateMenu = $$v
                    },
                    expression: "shipDateMenu"
                  }
                },
                [
                  _vm._v(" "),
                  _c("v-date-picker", {
                    on: {
                      input: function($event) {
                        _vm.shipDateMenu = false
                      }
                    },
                    model: {
                      value: _vm.shipDate,
                      callback: function($$v) {
                        _vm.shipDate = $$v
                      },
                      expression: "shipDate"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs3: "" } },
            [
              _c("v-select", {
                attrs: {
                  "hide-details": "",
                  items: _vm.filterShippingServiceByFromState(
                    _vm.shippingServices,
                    _vm.fromState
                  ),
                  "item-text": "text",
                  "item-value": "value",
                  "menu-props": { returnValue: "value" },
                  rules: [_vm.fieldIsRequired("service"), _vm.checkShipForm()],
                  label: _vm.$t("shippingService")
                },
                scopedSlots: _vm._u([
                  {
                    key: "item",
                    fn: function(data) {
                      return [
                        _vm.isObject(data.item)
                          ? [
                              _c("v-list-tile-content", {
                                domProps: { textContent: _vm._s(data.item) }
                              })
                            ]
                          : [
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(data.item.text) +
                                        "\n              "
                                    )
                                  ])
                                ],
                                1
                              )
                            ]
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.shippingService,
                  callback: function($$v) {
                    _vm.shippingService = $$v
                  },
                  expression: "shippingService"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs2: "" } },
            [
              _c("v-select", {
                staticClass: "table-item",
                attrs: {
                  "hide-details": "",
                  label: _vm.$t("signature"),
                  items: _vm.signatureOptions,
                  "item-text": "text",
                  "menu-props": { returnValue: "value" }
                },
                model: {
                  value: _vm.signature,
                  callback: function($$v) {
                    _vm.signature = $$v
                  },
                  expression: "signature"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs2: "" } },
            [
              _c("v-select", {
                staticClass: "table-item",
                attrs: {
                  "hide-details": "",
                  label: _vm.$t("labelStockType"),
                  items: _vm.labelStockTypes,
                  "item-text": "text",
                  "menu-props": { returnValue: "value" },
                  disabled: !_vm.isSupportLabelStockType
                },
                model: {
                  value: _vm.labelStockType,
                  callback: function($$v) {
                    _vm.labelStockType = $$v
                  },
                  expression: "labelStockType"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { "justify-space-between": "" } },
        [
          _c(
            "v-flex",
            _vm._b(
              {},
              "v-flex",
              {
                md6: _vm.isSupportSaturdayDelivery,
                md7: !_vm.isSupportSaturdayDelivery
              },
              false
            ),
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("note"),
                  hint: _vm.$t("noteWillNotBePrintedOnLabel"),
                  rules: [_vm.fieldCharLimit("Note", 100)],
                  counter: "100"
                },
                model: {
                  value: _vm.note,
                  callback: function($$v) {
                    _vm.note = typeof $$v === "string" ? $$v.trim() : $$v
                  },
                  expression: "note"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            _vm._b(
              {},
              "v-flex",
              {
                md3: _vm.isSupportSaturdayDelivery,
                md4: !_vm.isSupportSaturdayDelivery
              },
              false
            ),
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("memo"),
                  hint: _vm.$t("memoWillBePrintedOnLabel"),
                  rules: [_vm.fieldCharLimit("Memo", 40)],
                  counter: "40"
                },
                model: {
                  value: _vm.memo,
                  callback: function($$v) {
                    _vm.memo = typeof $$v === "string" ? $$v.trim() : $$v
                  },
                  expression: "memo"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.isSupportSaturdayDelivery
            ? _c(
                "v-flex",
                { attrs: { md2: "" } },
                [
                  _c("v-checkbox", {
                    attrs: { label: _vm.$t("supportSaturdayDelivery") },
                    model: {
                      value: _vm.isSaturdayDelivery,
                      callback: function($$v) {
                        _vm.isSaturdayDelivery = $$v
                      },
                      expression: "isSaturdayDelivery"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "elevation-2 mt-2",
        attrs: {
          headers: _vm.headers,
          items: _vm.packages,
          "hide-actions": "",
          "item-key": "index",
          caption: ""
        },
        scopedSlots: _vm._u([
          {
            key: "headerCell",
            fn: function(props) {
              return [
                props.header.value === "action"
                  ? _c(
                      "span",
                      [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { top: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(tooltip) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          {
                                            attrs: {
                                              color: "primary",
                                              flat: "",
                                              small: "",
                                              icon: "",
                                              disabled: !_vm.serviceSetting
                                                .enableMWT
                                            },
                                            on: { click: _vm.addPackage }
                                          },
                                          tooltip.on
                                        ),
                                        [_c("v-icon", [_vm._v("add")])],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t("supportUpToMaxPkgQtyPackages", {
                                    maxPkgQty: _vm.serviceSetting.maxPkgQty
                                  })
                                ) +
                                "\n        "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _c("span", [_vm._v(_vm._s(props.header.text))])
              ]
            }
          },
          {
            key: "items",
            fn: function(props) {
              return [
                _c(
                  "td",
                  { staticClass: "text-xs-center" },
                  [
                    props.index > 0
                      ? _c(
                          "v-btn",
                          {
                            attrs: {
                              color: "primary",
                              flat: "",
                              small: "",
                              icon: ""
                            },
                            on: {
                              click: function($event) {
                                return _vm.deletePackage(props.item)
                              }
                            }
                          },
                          [_c("v-icon", [_vm._v("delete")])],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { attrs: { "text-xs-center": "" } },
                  [
                    _c("v-text-field", {
                      staticClass: "table-item",
                      attrs: {
                        "hide-details": "",
                        rules: [_vm.fieldIsRequired("description")]
                      },
                      model: {
                        value: props.item.description,
                        callback: function($$v) {
                          _vm.$set(props.item, "description", $$v)
                        },
                        expression: "props.item.description"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-left" },
                  [
                    _c(
                      "v-layout",
                      { attrs: { "align-baseline": "", "justify-center": "" } },
                      [
                        _c(
                          "v-flex",
                          { attrs: { xs6: "", "pr-2": "" } },
                          [
                            _c("v-text-field", {
                              staticClass: "table-item",
                              attrs: {
                                "hide-details": "",
                                disabled: !_vm.serviceSetting.enableMWT,
                                rules: [
                                  _vm.fieldIsRequired("qty"),
                                  _vm.fieldIsOverZero("qty"),
                                  _vm.fieldIsInteger("qty")
                                ]
                              },
                              model: {
                                value: props.item.qty,
                                callback: function($$v) {
                                  _vm.$set(props.item, "qty", _vm._n($$v))
                                },
                                expression: "props.item.qty"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v("\n            /\n          "),
                        _c(
                          "v-flex",
                          { attrs: { xs6: "", "pl-2": "" } },
                          [
                            _c("v-text-field", {
                              staticClass: "table-item",
                              attrs: {
                                "hide-details": "",
                                rules: [
                                  _vm.fieldIsRequired("pieces"),
                                  _vm.fieldIsOverZero("pieces"),
                                  _vm.fieldIsInteger("pieces")
                                ]
                              },
                              model: {
                                value: props.item.pieces,
                                callback: function($$v) {
                                  _vm.$set(props.item, "pieces", _vm._n($$v))
                                },
                                expression: "props.item.pieces"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-left" },
                  [
                    _c("v-text-field", {
                      staticClass: "table-item",
                      attrs: {
                        "hide-details": "",
                        rules: [
                          _vm.fieldIsRequired("weight"),
                          _vm.fieldIsNoLessThanZero("weight"),
                          _vm.isMeasurementMetric
                            ? function() {
                                return true
                              }
                            : _vm.fieldIsPkgWeight(_vm.isOz)
                        ],
                        suffix: _vm.isMeasurementMetric
                          ? "kg"
                          : _vm.isOz
                          ? "Oz"
                          : "Lbs"
                      },
                      model: {
                        value: props.item.weightLb,
                        callback: function($$v) {
                          _vm.$set(props.item, "weightLb", _vm._n($$v))
                        },
                        expression: "props.item.weightLb"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-left" },
                  [
                    _c(
                      "v-layout",
                      { attrs: { "align-center": "" } },
                      [
                        _c(
                          "v-flex",
                          { staticClass: "mr-3", attrs: { xs4: "" } },
                          [
                            _c("v-text-field", {
                              staticClass: "table-item",
                              attrs: {
                                "hide-details": "",
                                suffix: _vm.sizeSuffix,
                                rules: [
                                  _vm.fieldIsRequired("length"),
                                  _vm.fieldIsOverZero("length")
                                ]
                              },
                              model: {
                                value: props.item.length,
                                callback: function($$v) {
                                  _vm.$set(props.item, "length", _vm._n($$v))
                                },
                                expression: "props.item.length"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { staticClass: "mr-3", attrs: { xs4: "" } },
                          [
                            _c("v-text-field", {
                              staticClass: "table-item",
                              attrs: {
                                "hide-details": "",
                                suffix: _vm.sizeSuffix,
                                rules: [
                                  _vm.fieldIsRequired("width"),
                                  _vm.fieldIsOverZero("width")
                                ]
                              },
                              model: {
                                value: props.item.width,
                                callback: function($$v) {
                                  _vm.$set(props.item, "width", _vm._n($$v))
                                },
                                expression: "props.item.width"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs4: "" } },
                          [
                            _c("v-text-field", {
                              staticClass: "table-item",
                              attrs: {
                                "hide-details": "",
                                suffix: _vm.sizeSuffix,
                                rules: [
                                  _vm.fieldIsRequired("height"),
                                  _vm.fieldIsOverZero("height")
                                ]
                              },
                              model: {
                                value: props.item.height,
                                callback: function($$v) {
                                  _vm.$set(props.item, "height", _vm._n($$v))
                                },
                                expression: "props.item.height"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs1: "" } },
                          [
                            _c("PackagingSelector", {
                              attrs: { packagings: _vm.packagings },
                              on: {
                                select: function(item) {
                                  return _vm.onSelectPackaging(item, props.item)
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-left" },
                  [
                    _c("LabelFreightClassSelector", {
                      attrs: {
                        length: props.item.length,
                        width: props.item.width,
                        height: props.item.height,
                        weight: props.item.weightLb,
                        isMeasurementMetric: _vm.isMeasurementMetric
                      },
                      model: {
                        value: props.item.freightClass,
                        callback: function($$v) {
                          _vm.$set(props.item, "freightClass", $$v)
                        },
                        expression: "props.item.freightClass"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-left" },
                  [
                    _c("v-text-field", {
                      staticClass: "table-item",
                      attrs: {
                        "hide-details": "",
                        disabled: !_vm.serviceSetting.enableInsured,
                        rules: [
                          _vm.fieldIsRequired("value"),
                          _vm.fieldIsNoLessThanZero("value")
                        ]
                      },
                      on: {
                        change: function(e) {
                          return _vm.defaultZero(e, props.item)
                        }
                      },
                      model: {
                        value: props.item.insuredValue,
                        callback: function($$v) {
                          _vm.$set(props.item, "insuredValue", _vm._n($$v))
                        },
                        expression: "props.item.insuredValue"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-left" },
                  [
                    _c(
                      "v-edit-dialog",
                      {
                        attrs: { "return-value": props.item.memo, lazy: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "input",
                              fn: function() {
                                return [
                                  _c("div", { staticClass: "mt-3" }, [
                                    _vm._v(_vm._s(_vm.$t("memo")))
                                  ]),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: _vm.$t("edit"),
                                      "single-line": "",
                                      autofocus: ""
                                    },
                                    model: {
                                      value: props.item.memo,
                                      callback: function($$v) {
                                        _vm.$set(
                                          props.item,
                                          "memo",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "props.item.memo"
                                    }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        )
                      },
                      [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { top: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          { attrs: { icon: "", flat: "" } },
                                          on
                                        ),
                                        [_c("v-icon", [_vm._v("note")])],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(props.item.memo || "** no memo **") +
                                "\n          "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ada55c1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ada55c1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LabelFreightPkgWidget.vue
// module id = null
// module chunks = 